export default function InvitePage(): React.ReactElement {
  return (
    <main style={styles.page}>
      <div style={styles.card}>
        <h1 style={styles.title}>Ask for a new invitation</h1>
        <p style={styles.body}>
          This older link cannot create an account. Ask the person who invited you to send a new link.
        </p>
      </div>
    </main>
  );
}

const styles: Record<string, React.CSSProperties> = {
  page: { minHeight: "100vh", display: "grid", placeItems: "center", background: "var(--surface-2)", color: "var(--text)", padding: 24 },
  card: { width: "min(460px, 100%)", boxSizing: "border-box", background: "var(--surface)", border: "1px solid var(--border)", borderRadius: 12, padding: 32 },
  title: { margin: 0, fontSize: 26, lineHeight: 1.2 },
  body: { margin: "12px 0 0", color: "var(--body)", fontSize: 15, lineHeight: 1.55 },
};
